import { isSSR } from "@website/utils/is-ssr";

const STORAGE_KEY = "tracking_store";

let defaultValue = {
  sid: "",
  aid: "",
  uid: "",
  isNative: false,
  sessionExpire: 0,
  queue: [] as Array<object>,
  experiment: {} as Record<string, string | number | boolean | undefined>,
  previousUrl: "",
  hotelPriceEngineRuleId: 0
};

if (!isSSR()) {
  if (localStorage.getItem(STORAGE_KEY)) {
    try {
      defaultValue = {
        ...defaultValue,
        ...JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}")
      };
    } catch {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultValue));
    }
  } else {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultValue));
  }
}

export const getTracking = () => defaultValue;

export const setTracking = (
  setter: (previous: typeof defaultValue) => typeof defaultValue
) => {
  const newValue = setter(getTracking());
  defaultValue = { ...newValue };
  if (!isSSR()) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newValue));
  }
};
